var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"flash-transit"}},[(_vm.visible)?_c('div',{staticClass:"flashWrapper-js",on:{"click":_vm.toggle}},[_c('i',{staticClass:"fas fa-bell iconFlash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.status))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }